import { MIN_WIDTH_BREAKPOINTS } from "@faire/web--source/common/media";
export var DEFAULT_MIN_WIDTH_BREAKPOINTS = {
    tablet: MIN_WIDTH_BREAKPOINTS.TABLET,
    desktop: MIN_WIDTH_BREAKPOINTS.DESKTOP,
    xlarge: MIN_WIDTH_BREAKPOINTS.XLARGE,
    xxlarge: MIN_WIDTH_BREAKPOINTS.XXLARGE
};
export var getViewportValues = function(width, minWidthBreakpoints) {
    var isMobile = width < minWidthBreakpoints.tablet;
    var isTablet = minWidthBreakpoints.tablet <= width && width < minWidthBreakpoints.desktop;
    var isDesktop = minWidthBreakpoints.desktop <= width && width < minWidthBreakpoints.xlarge;
    var _minWidthBreakpoints_xxlarge;
    var isXLargeDesktop = width >= minWidthBreakpoints.xlarge && width < ((_minWidthBreakpoints_xxlarge = minWidthBreakpoints.xxlarge) !== null && _minWidthBreakpoints_xxlarge !== void 0 ? _minWidthBreakpoints_xxlarge : MIN_WIDTH_BREAKPOINTS.XXLARGE);
    var _minWidthBreakpoints_xxlarge1;
    var isXXLargeDesktop = width >= ((_minWidthBreakpoints_xxlarge1 = minWidthBreakpoints.xxlarge) !== null && _minWidthBreakpoints_xxlarge1 !== void 0 ? _minWidthBreakpoints_xxlarge1 : MIN_WIDTH_BREAKPOINTS.XXLARGE);
    var isTabletAndAbove = width >= minWidthBreakpoints.tablet;
    var isDesktopAndAbove = width >= minWidthBreakpoints.desktop;
    var isXLargeAndAbove = width >= minWidthBreakpoints.xlarge;
    var isTabletAndBelow = !isDesktopAndAbove;
    return {
        isMobile: isMobile,
        isTablet: isTablet,
        isDesktop: isDesktop,
        isXLargeDesktop: isXLargeDesktop,
        isXXLargeDesktop: isXXLargeDesktop,
        isTabletAndAbove: isTabletAndAbove,
        isDesktopAndAbove: isDesktopAndAbove,
        isXLargeAndAbove: isXLargeAndAbove,
        isTabletAndBelow: isTabletAndBelow
    };
};
